import AbstractService from 'core/abstracts/AbstractService';
import Facade from 'core/Facade';

class SignService extends AbstractService {

    /**
     * Sign in with a username and password.
     */
    getToken(options) {
        // if no credentials were provided, reject
        if (!options.login || !options.password) {
            return Promise.reject();
        }

        return this.request({
            method: 'POST',
            url:  Facade.getApiRoot() + 'bo/auth ',
            json: {
                login: options.login,
                pwd: options.password
            }
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.clone().json();
            }
            throw responseData.ok;
        });
    }

    tokenExists() {
        return this.request({
            method: 'GET',
            url:  Facade.getApiRoot() + 'bo/tokens/self/is-valid'
        }).then(responseData => {
            if (responseData.ok) {
                return responseData.json();
            }
        });
    }
}

export default new SignService();
